/*#__PURE__*/ export default JSON.parse('{"key":"classicCards","type":"root","items":[]}');